import React, { FC } from 'react';
import { HeaderGroup } from 'react-table';
import { NextTableSorter } from './sorter';
import { StyledNextTable } from '../styled';

type ITableHeadProps = { headerGroups: HeaderGroup[]; filterable: boolean };

export const NextTableHead: FC<ITableHeadProps> = ({ headerGroups, filterable }) => {
  return (
    <StyledNextTable.Thead>
      {headerGroups.map((headerGroup) => {
        const { key: headerGroupKey, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
        return (
          <StyledNextTable.Tr key={headerGroupKey} {...headerGroupProps}>
            {headerGroup.headers.map((column: any) => {
              const { key: columnKey, ...columnProps } = column.getHeaderProps(column.sortable ? column.getSortByToggleProps() : {});
              return (
                <StyledNextTable.Th key={columnKey} {...columnProps}>
                  {column.render('Header')}
                  {column.sortable && <NextTableSorter dir={column.isSorted ? (column.isSortedDesc ? 'desc' : 'asc') : undefined} />}
                </StyledNextTable.Th>
              );
            })}
          </StyledNextTable.Tr>
        );
      })}
      {filterable &&
        headerGroups.map((headerGroup) => {
          const { key: headerGroupKey, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
          return (
            <StyledNextTable.Tr key={`filter-${headerGroupKey}`} {...headerGroupProps}>
              {headerGroup.headers.map((column: any) => {
                const { key: columnKey, ...columnProps } = column.getHeaderProps();
                return (
                  <StyledNextTable.Th key={columnKey} {...columnProps}>
                    {column.filterable ? column.render('Filter') : null}
                  </StyledNextTable.Th>
                );
              })}
            </StyledNextTable.Tr>
          );
        })}
    </StyledNextTable.Thead>
  );
};
